// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1kbQQ","select":"Header_select__FuKbT","clinic":"Header_clinic__2_S_r"};